import type { RecitalResumeState, ResumeState } from "@recital-master/shared";

function record(value: unknown): Record<string, unknown> | null {
  return value != null && typeof value === "object"
    ? (value as Record<string, unknown>)
    : null;
}

function identifier(value: unknown): string | null {
  return typeof value === "string" && value.length > 0 ? value : null;
}

export function normalizeResumeState(
  value: unknown,
  documentId: string
): ResumeState | null {
  const raw = record(value);
  if (!raw) return null;
  const performanceId = identifier(raw.performanceId);
  if (
    !performanceId ||
    performanceId !== documentId ||
    (raw.mode !== "full-performance" && raw.mode !== "my-dancer") ||
    !identifier(raw.recitalId) ||
    !identifier(raw.danceId)
  ) {
    return null;
  }
  return raw as ResumeState;
}

export function normalizeRecitalResumeState(
  value: unknown,
  documentId: string
): RecitalResumeState | null {
  const raw = record(value);
  if (!raw) return null;
  const performanceId = identifier(raw.performanceId);
  const recitalId = identifier(raw.recitalId);
  if (
    !performanceId ||
    !recitalId ||
    recitalId !== documentId ||
    (raw.mode !== "full-recital" && raw.mode !== "my-dancer") ||
    !identifier(raw.danceId)
  ) {
    return null;
  }
  return raw as RecitalResumeState;
}

export function resumeDocumentForWrite(state: ResumeState) {
  return state;
}

export function recitalResumeDocumentForWrite(state: RecitalResumeState) {
  return state;
}
